<template>
  <div class="field" :class="[{ field_row: isRow }]" @click="handleClick">
    <div class="field__label">
      <span :class="[{ field__require: isRequire }]">{{ title }}</span>
      <span v-if="$slots['label-append']">
        <slot name="label-append" />
      </span>
    </div>
    <div class="field__value">
      <slot />
    </div>
    <div class="field__arrow">
      <slot name="action" />
      <base-icon v-if="isLink" name="mine_right" />
    </div>
  </div>
</template>

<style lang="less" scoped>
.field {
  position: relative;
  padding: 40px;
  background-color: #fff;
  line-height: 1;
  width: 100%;
  &.field_row {
    display: flex;
    padding: 45px 40px;
    flex-direction: row;
    align-items: center;
    .field__label {
      margin-bottom: 0;
      padding-left: 30px;
      font-size: 30px;
      color: #666666;
      flex-shrink: 0;
    }
    .field__value {
      position: relative;
      top: -1px;
      flex: 1;
      margin-left: 40px;
      color: #262626;
      font-weight: 500;
    }
    .field__require::after {
      content: "*";
      position: absolute;
      left: -20px;
      top: 50%;
      transform: translateY(-40%);
      color: #fd5c60;
    }
    &:after {
      content: "";
      display: block;
      position: absolute;
      left: 40px;
      right: 40px;
      bottom: 0;
      height: 2px;
      background-color: #dcdfe6a9;
    }
  }
  &:after {
    content: "";
    display: block;
    position: absolute;
    left: 40px;
    right: 40px;
    bottom: 0;
    height: 2px;
    background-color: #edeef2;
  }

  &__label {
    display: flex;
    justify-content: space-between;
    font-size: 26px;
    color: #666;
    margin-bottom: 30px;
    > span {
      position: relative;
      &.field__require {
        &:after {
          content: "*";
          position: absolute;
          right: -20px;
          top: 50%;
          transform: translateY(-40%);
          color: #fd5c60;
        }
      }
    }
  }
  &__value {
    font-size: 32px;
    color: #333;
    line-height: 32px;
  }
  &__arrow {
    position: absolute;
    right: 40px;
    top: 50%;
    display: flex;
    align-items: center;
    transform: translateY(-50%);
    /deep/ .svg-icon {
      display: block;
      width: 24px;
      height: 24px;
    }
  }
}
</style>

<script>
export default {
  name: 'FormField',
  props: {
    title: String,
    isLink: {
      type: Boolean,
      default: false,
    },
    isRequire: {
      type: Boolean,
      default: false,
    },
    isRow: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e);
    },
  },
};
</script>
